import {
  LuClipboardList,
  LuHistory,
  LuLayoutPanelLeft,
  LuUsers
} from 'react-icons/lu'

export const menuItems = [
  {
    title: 'Panell',
    slug: '/',
    active: true,
    requiredPermissions: null,
    icon: (
      <LuLayoutPanelLeft
        className={`cursor-pointer float-left rounded-sm block`}
        size={26}
      />
    )
  },
  {
    title: 'Contractes',
    slug: '/contractes',
    active: true,
    requiredPermissions: null,
    icon: (
      <LuClipboardList
        className={`cursor-pointer float-left rounded-sm block`}
        size={26}
      />
    )
  },
  {
    title: 'Històric',
    slug: '/contractes/historic',
    active: true,
    requiredPermissions: null,
    icon: (
      <LuHistory
        className={`cursor-pointer float-left rounded-sm block`}
        size={26}
      />
    )
  },
  {
    title: 'Usuaris',
    slug: '/users/grid',
    active: true,
    requiredPermissions: null,
    icon: (
      <LuUsers
        className={`cursor-pointer float-left rounded-sm block`}
        size={26}
      />
    )
  }
]
